import { Directive, Injector, ElementRef, TemplateRef, ViewContainerRef } from '@angular/core';

import { ClientPermissionDirectivesBase } from './base-client';

import { CLIENT_TYPES } from 'src/app/authorization/authentication.service';

@Directive({
    selector: '[ALL_ACCESS]'
})
export class DirectiveAllAccessDirectiveAC extends ClientPermissionDirectivesBase {

    constructor(
        injector: Injector,
        element: ElementRef,
        templateRef: TemplateRef<any>,
        viewContainer: ViewContainerRef
    ) {
        super(injector, element, templateRef, viewContainer, CLIENT_TYPES.ALL_ACCESS);
    }
}